import whatsappSource from '../assets/Inquiry/whatsappSource.png';
import instagramSource from '../assets/Inquiry/instagramSource.png';
import facebookSource from '../assets/Inquiry/facebookSource.png';
import threadsSource from '../assets/Inquiry/threadsSource.png';
import csvSource from '../assets/Inquiry/csvSource.png';
import manualSource from '../assets/Inquiry/manualSource.png';
import gmailSource from '../assets/gmail_icon.png';

// Matched via `.includes()` against the lowercased source_type string, so
// e.g. "csv_import" and "Instagram DM" both resolve correctly.
const SOURCE_ICONS = {
  whatsapp: whatsappSource,
  instagram: instagramSource,
  facebook: facebookSource,
  threads: threadsSource,
  thread: threadsSource,
  gmail: gmailSource,
  email: gmailSource,
  mail: gmailSource,
  csv: csvSource,
  excel: csvSource,
  manual: manualSource,
};

/**
 * Shared lead/contact source icon — same icon set everywhere a
 * source_type ("whatsapp", "instagram", "facebook", "threads",
 * "csv_import", ...) needs a visual. Falls back to a colored initial
 * badge for source types without a dedicated icon (e.g. "manual").
 */
export function SourceIcon({ type, className = 'w-5 h-5' }) {
  const normalized = String(type || '').toLowerCase();
  const matchedKey = Object.keys(SOURCE_ICONS).find((key) =>
    normalized.includes(key),
  );

  if (matchedKey) {
    return (
      <img
        src={SOURCE_ICONS[matchedKey]}
        alt=""
        className={`${className} object-contain shrink-0`}
      />
    );
  }

  return (
    <span
      className={`${className} rounded-full bg-[#EBF4EA] text-[#50AB3D] text-[10px] font-bold flex items-center justify-center shrink-0`}
    >
      {normalized.charAt(0).toUpperCase() || '?'}
    </span>
  );
}
